import { NoticePopup } from 'components/notice-popup-slider';

import chuseokHolidayPopup from 'assets/images/chuseok-holiday-2026.png';
import locationTermsPopup from 'assets/images/location-terms-revision-2026.png';
import securityUpdatePopup from 'assets/images/security-update-2026-1027.png';

// 배열 앞쪽이 1순위. 기간이 겹치면 슬라이드 첫 장으로 노출
export const LOGIN_POPUPS: NoticePopup[] = [
  {
    id: 'security-update-2026-1027',
    storageKey: 'loginPopupHideUntil_securityUpdate20261027',
    startAt: '2026-10-27T00:00:00+09:00',
    endAt: '2026-10-27T23:59:59+09:00',
    image: securityUpdatePopup,
    imageAlt: '서버 보안 업데이트 안내',
    aspectRatio: 960 / 1322,
  },
  {
    id: 'chuseok-holiday-2026',
    storageKey: 'loginPopupHideUntil_chuseokHoliday2026',
    startAt: '2026-09-23T10:00:00+09:00',
    endAt: '2026-09-28T10:00:00+09:00',
    image: chuseokHolidayPopup,
    imageAlt: '추석 휴무안내',
    aspectRatio: 638 / 900,
  },
  {
    id: 'location-terms-revision-2026',
    storageKey: 'loginPopupHideUntil5',
    startAt: '2026-09-14T00:00:00+09:00',
    endAt: '2026-10-14T23:59:59+09:00',
    image: locationTermsPopup,
    imageAlt: '공지사항',
    aspectRatio: 1524 / 739,
  },
];
